import React, { useCallback, useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import {
  makeStyles,
  Box,
  Typography,
  Link,
} from '@material-ui/core';
import classnames from 'classnames';
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import LaunchIcon from '@material-ui/icons/Launch';
import CAM4_BADGE from '../../../assets/Hedonism/cam4-badge.png';
import TEMPTED_BADGE from '../../../assets/Hedonism/tempted-badge.png';

import stylesCreator from './styles';

const CLICK_TIMEOUT_DELAY = 3000;


const useStyles = makeStyles(stylesCreator);
const SCROLL_DISTANCE = 280;

const LEFT_ARROW_ID = 'left-arrow';
const RIGHT_ARROW_ID = 'right-arrow';
const NAKED_NEWS_LIVE_ID = 241;


const LiveStreams = ({
  streams,
  onCameraSelect,
  selectedStreamID,
  eventParticipants,
  user,
}) => {
  const classes = useStyles();
  const [scrollableScrolledLeft, setScrollableScrolledLeft] = useState(0);
  const [arrowsVisibility, setArrowsVisibility] = useState({ left: false, right: false });
  const [scrollableNode, setScrollableNode] = useState();
  const [clickTimeout, setClickTimeout] = useState(null);
  const [disableClick, setDisableClick] = useState(false);
  const { account } = user?.user || {};
  const subscribedToNakedNewsLive = account?.anchorSubscriptions?.
    find((subscription) => parseInt(subscription?.subCategory, 10) === NAKED_NEWS_LIVE_ID);

  const onRefChanged = useCallback((node) => {
    if (node !== null) {
      const left = scrollableScrolledLeft > 0;
      const right = node && node.scrollWidth - node.clientWidth - scrollableScrolledLeft > 3;
      setScrollableNode(node);
      setArrowsVisibility({ left, right });
    }
  }, [scrollableScrolledLeft]);

  const onScrollableScroll = useCallback((event) => {
    setScrollableScrolledLeft(event.target.scrollLeft);
  }, []);

  const scrollTo = useCallback((event) => {
    let xScrollTo = 0;
    const { id } = event.currentTarget;

    if (id === LEFT_ARROW_ID) {
      xScrollTo = scrollableScrolledLeft - SCROLL_DISTANCE;
    }

    if (id === RIGHT_ARROW_ID) {
      xScrollTo = scrollableScrolledLeft + SCROLL_DISTANCE;
    }

    scrollableNode.scroll(xScrollTo, 0);
  }, [scrollableScrolledLeft, scrollableNode]);

  const onCameraSelectHandler = useCallback((stream) => {
    if (disableClick) {
      return;
    }
    onCameraSelect(stream);
    setDisableClick(true);
    const clickTimeoutId = setTimeout(() => {
      setClickTimeout(clickTimeoutId);
      setDisableClick(false);
    }, CLICK_TIMEOUT_DELAY);
  }, [disableClick, onCameraSelect]);

  const getStreamBadge = (streamStatus) => {
    let badge = TEMPTED_BADGE;

    if (streamStatus === 'IS_BROADCASTING_ON_CAM4') {
      badge = CAM4_BADGE;
    }

    return badge;
  };

  useEffect(() => {
    return () => {
      if (clickTimeout) {
        clearTimeout(clickTimeout);
      }
    }
  }, []);

  return (
    <Box className={classes.wrapper}>
      <Box
        overflow="hidden"
        position="relative"
        textAlign="left"
      >
        <Box
          ref={onRefChanged}
          className={classes.sliderWrapper}
          onScroll={onScrollableScroll}
        >
          <Box
            className={classes.slider}
          >
            {!isMobile && (
              <>
                <Box
                  className={`${classes.arrow} ${classes.arrowLeft}`}
                  id={LEFT_ARROW_ID}
                  style={{ display: `${arrowsVisibility.left ? 'flex' : 'none'}` }}
                  onClick={scrollTo}
                >
                  <KeyboardArrowLeftIcon className={classes.arrowIcon} />
                </Box>
                <Box
                  className={`${classes.arrow} ${classes.arrowRight}`}
                  id={RIGHT_ARROW_ID}
                  style={{ display: `${arrowsVisibility.right ? 'flex' : 'none'}` }}
                  onClick={scrollTo}
                >
                  <KeyboardArrowRightIcon className={classes.arrowIcon} />
                </Box>
              </>
            )}
            {streams?.map((stream) => (
              <Box
                key={stream.streamUri}
                alignItems="center"
                className={classnames(
                  classes.thumbnail, {
                  [classes.selected]: stream.streamUri === selectedStreamID,
                  [classes.disableClick]: !subscribedToNakedNewsLive ||
                    (stream.profileStatus === 'NOT_BROADCASTING' || disableClick),
                })
                }
                display="flex"
                justifyContent="center"
                style={{ backgroundImage: `url(${stream.thumbnailUri})` }}
                onClick={() => onCameraSelectHandler(stream)}
              >
                <Box className={classes.nameWrapperStyles}>
                  <Typography
                    className={classes.nameStyles}
                  >
                    {stream?.label || stream?.name || stream?.nickname}
                  </Typography>
                </Box>
              </Box>
            ))}
            {eventParticipants.map((profile) => {
              if (profile.temptationId === NAKED_NEWS_LIVE_ID) {
                return null;
              }

              return (
                <Link
                  key={profile.temptationId}
                  className={classes.thumbnail}
                  href={profile.url}
                  overflow="hidden"
                  position="relative"
                  style={{ backgroundImage: `url(${profile.profileImage})` }}
                  target="_blank"
                >
                  <Box className={classes.nameWrapperStyles}>
                    <Typography
                      className={classes.nameStyles}
                    >
                      {profile?.name || profile?.nickname}
                    </Typography>
                  </Box>
                  {profile.isLive && (
                    <React.Fragment>
                      <Box className={classes.liveIndicatorStyles}>
                        <Box className={classes.liveBadge}>LIVE</Box>
                      </Box>
                    </React.Fragment>
                  )}
                  <Box
                    position="absolute"
                    right={1}
                    top={1}
                  >
                    <Box className={classes.launchIconStyles}>
                      <LaunchIcon />
                    </Box>
                  </Box>
                </Link>
              );
            })}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default LiveStreams;
